
import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";
import FormValidator from "@/components/mixins/FormValidator";
interface Tipos {
  value: number | any;
  label: string;
}
interface SelectOption {
  value: number | any;
  label: string;
}
@Component({
  components: {
    FormValidator
  }
})
export default class StepDireccion extends Mixins(FormValidator) {
  @Prop({ required: true })
  private tipoVecino!: any;
  @Prop({ required: true })
  private flotante!: any;
  @Prop({ required: true })
  private directoForm!: any;
  private streetsList: any[] = [];
  private streetsListOptions: Array<any> = [];
  private comunaOptions: SelectOption[] = [];
  private zonaOptions: SelectOption[] = [];
  private cityList: any[] = [];
  private zonaList: any[] = [];
  private dialogAddress = false;
  private dataSolicitud: any = "";
  private dataZona: Tipos = {
    value: null,
    label: " "
  };
  private dataCalle: Tipos = {
    value: null,
    label: " "
  };
  private dataComuna: Tipos = {
    value: null,
    label: " "
  };

  private dataForm = {
    calle: "",
    calle_id: null as number | null,
    comuna: "",
    comuna_id: null as number | null,
    zona: "",
    zona_id: null as number | any,
    referencia: "",
    numero: "" as string | null,
    bloque: "" as string | undefined,
    depto: "" as string | undefined
  };

  @Watch("dataZona")
  private zonaWatcher(newValue: any) {
    if (newValue && newValue.label == "SIN INFORMACIÓN") {
      this.dataForm.zona_id = 9999;
      this.dataForm.zona = "SIN INFORMACIÓN";
    } else {
      this.dataForm.zona_id = newValue.value;
      this.dataForm.zona = newValue.label;
    }
  }

  @Watch("dataComuna")
  private comunaWatcher(newValue: any) {
    this.dataForm.comuna_id = newValue.value;
  }

  @Watch("dataCalle")
  private calleWatcher(newValue: any) {
    this.dataForm.calle_id = newValue.value;
    this.dataForm.calle = newValue.label;
  }

  private mounted() {
    this.dataSolicitud = this.$store.state.solicitud;

    this.$axios("comunas")
      .then(res => {
        res.data.forEach((city: any) => {
          this.cityList.push({
            value: city.id,
            label: city.nombre
          });
          if (this.dataForm.comuna_id === -1 && this.dataForm.comuna) {
            this.cityList.push({
              value: this.dataForm.comuna_id,
              label: this.dataForm.comuna
            });
          } else if (this.dataForm.comuna_id === -1) {
            this.dataForm.comuna_id = null;
          }
          if (city.id == this.dataForm.comuna_id) {
            this.dataComuna = {
              value: city.id,
              label: city.nombre
            };
          }
        });
      })
      .catch((error: any) => {
        if (error.response.data.message == "TOKEN_ERROR") {
          this.$swal({
            icon: "warning",
            title: this.$t("notifications.titles.atention").toString(),
            text: this.$t("notifications.error.TOKEN_ERROR").toString(),
            confirmButtonText: this.$t("buttons.accept").toString()
          });
          this.$router.push({ name: "login" }).catch(err => {});
        }
      });
    this.getZonas();
    this.fillForm(this.dataSolicitud);
  }

  private getZonas() {
    this.$axios("listado/zonas").then(res => {
      res.data.forEach((zone: any) => {
        this.zonaList.push({
          value: zone.id,
          label: zone.nombre
        });
        if (zone.id == this.dataForm.zona_id) {
          this.dataZona = {
            value: zone.id,
            label: zone.nombre
          };
        }
      });
      this.setZona(this.dataForm.zona);
    });
  }

  private calles() {
    this.$axios("streets")
      .then(res => {
        res.data.forEach((street: any) => {
          this.streetsList.push({
            value: street.id,
            label: street.nombre,
            min: street.min,
            max: street.max
          });

          if (street.id == this.dataForm.calle_id) {
            this.dataCalle = {
              value: street.id,
              label: street.nombre
            };
          }
        });

        this.setModel(this.dataForm.calle);

        // if (this.dataForm.calle_id === -1 && this.dataForm.calle) {
        //
        //     this.streetsList.push({
        //       value: this.dataForm.calle_id,
        //       label: this.dataForm.calle
        //     });
        //     this.setModel(this.dataForm.calle);
        //   } else if (this.dataForm.calle_id === -1) {
        //
        //     this.dataForm.calle_id = null;
        //       this.dataCalle = {
        //       value: 0,
        //       label: "sdwsadas "
        //     };

        //   }
      })
      .catch((error: any) => {
        if (error.response.data.message == "TOKEN_ERROR") {
          this.$swal({
            icon: "warning",
            title: this.$t("notifications.titles.atention").toString(),
            text: this.$t("notifications.error.TOKEN_ERROR").toString(),
            confirmButtonText: this.$t("buttons.accept").toString()
          });
          this.$router.push({ name: "login" }).catch(err => {});
        }
      });
  }
  private setZona(val: any) {
    let datos = {
      value: 0,
      label: val
    };
    if (val && val == "SIN INFORMACIÓN") {
      for (let i = 0; i < this.zonaList.length; i++) {
        if (this.zonaList[i].label == val) {
          datos = {
            value: this.zonaList[i].value,
            label: this.zonaList[i].label
          };
        }
      }

      this.dataZona = datos;
    }
  }
  private setModel(val: any) {
    let datos = {
      value: 0,
      label: val
    };
    if (val) {
      for (let i = 0; i < this.streetsList.length; i++) {
        if (this.streetsList[i].label == val) {
          datos = {
            value: this.streetsList[i].value,
            label: this.streetsList[i].label
          };
        }
      }
      this.dataCalle = datos;
    } else {
      val = this.$store.state.user.calle;
      for (let i = 0; i < this.streetsList.length; i++) {
        if (this.streetsList[i].label == val) {
          datos = {
            value: this.streetsList[i].value,
            label: this.streetsList[i].label
          };
        }
      }
      this.dataCalle = datos;
    }
  }

  private fillForm(data: any) {
    if (data.tipoVecino == 3 || data.tipoVecino == 2) {
      if (data && data.numero) {
        this.dataForm.numero = data.numero;
        this.dataForm.calle = data.calle;
        this.dataForm.zona = data.zona;
        this.dataForm.zona_id = data.zona_id;
        this.dataForm.comuna = data.comuna;
        this.dataForm.comuna_id = data.comuna_id;
        this.dataForm.referencia = data.referencia;
        this.dataForm.bloque = data.bloque;
        this.dataForm.depto = data.depto;
        this.dataForm.zona = "SIN INFORMACIÓN";
        this.dataForm.zona_id = 9999;
        this.setModel(data.calle);
      } else {
        this.dataForm.numero = this.$store.state.user.numero;
        this.setModel(this.$store.state.user.calle);
        this.dataForm.zona = "SIN INFORMACIÓN";
        this.dataForm.zona_id = 9999;
      }
    } else {
      if (data && data.numero) {
        this.dataForm.numero = data.numero;
      } else {
        this.dataForm.numero = this.$store.state.user.numero;
      }
      if ((data && data.zona && data.zona_id) || data.zona_id) {
        if (data.zona_id == 9999) {
          this.dataForm.zona = "SIN INFORMACIÓN";
          this.dataForm.zona_id = data.zona_id;

          this.getZonas();
          this.setZona(this.dataForm.zona);
        } else {
          this.dataForm.zona = data.zona;
          this.dataForm.zona_id = data.zona_id;
          this.getZonas();
          this.setZona(this.dataForm.zona);
        }
      }

      if (data && data.comuna && data.comuna_id) {
        this.dataForm.comuna = data.comuna;
        this.dataForm.comuna_id = data.comuna_id;
      } else {
        this.dataForm.comuna = "Pirque";
        this.dataForm.comuna_id = 85;
      }

      if (data && data.calle) {
        this.dataForm.calle = data.calle;
        this.dataForm.referencia = data.referencia;
        this.dataForm.bloque = data.bloque;
        this.dataForm.depto = data.depto;

        this.calles();
        this.setModel(data.calle);
      } else {
        this.dataForm.calle = this.$store.state.user.calle;
        this.dataForm.referencia = data.referencia;
        this.dataForm.bloque = data.bloque;
        this.dataForm.depto = data.depto;

        this.calles();
        this.setModel(this.dataForm.calle);
      }
    }
  }

  get isNotTitular() {
    if (this.$store.state.solicitud.parentesco === 1) {
      return false;
    }
    return true;
  }

  private filterFn(val, update, abort) {
    update(() => {
      const needle = val.toLowerCase();
      this.streetsListOptions = this.streetsList.filter(
        v => v.label.toLowerCase().indexOf(needle) > -1
      );
    });
  }
  private filterFnComuna(val, update, abort) {
    update(() => {
      const needle = val.toLowerCase();
      this.comunaOptions = this.cityList.filter(
        v => v.label.toLowerCase().indexOf(needle) > -1
      );
    });
  }

  private filterFnZona(val, update, abort) {
    update(() => {
      const needle = val.toLowerCase();
      this.zonaOptions = this.zonaList.filter(
        v => v.label.toLowerCase().indexOf(needle) > -1
      );
    });
  }

  private actionBack() {
    if (
      this.tipoVecino != 1 &&
      this.flotante == true &&
      this.directoForm == false
    ) {
      this.$store.dispatch("SET_STATE_TO_THREE");

      this.$emit("stepNext", {
        step: this.$store.state.solicitud.step
      });
    } else if (this.flotante == false && this.directoForm == false) {
      this.$store.dispatch("SET_STATE_TO_THREE");

      this.$emit("stepNext", {
        step: this.$store.state.solicitud.step
      });
    } else {
      this.$store.dispatch("SET_STATE_TO_TWO");
      this.$emit("stepNext", {
        step: this.$store.state.solicitud.step
      });
    }
  }

  private stepToDocumentos() {
    if (
      (this.dataForm.comuna == "" && this.dataForm.comuna_id == null) ||
      (this.dataForm.comuna == undefined &&
        this.dataForm.comuna_id == undefined)
    ) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_COMUNA").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (this.dataForm.calle == "") {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_CALLE").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (
      (this.dataForm.zona == "" && this.dataForm.zona_id == null) ||
      (this.dataForm.zona == undefined && this.dataForm.zona_id == undefined)
    ) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_ZONA").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (this.dataForm.numero == "") {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.NO_NUMERO").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    if (this.tipoVecino == 2 || this.tipoVecino == 3) {
      this.dataForm.calle_id = -1;
    }

    if (this.flotante == false && this.directoForm == true) {
      this.$store.dispatch("SUBMIT_REQUEST_STEP_THREE", this.dataForm);
      this.$store.dispatch("SET_STATE_TO_FOUR");

      this.$emit("stepNext", {
        step: this.$store.state.solicitud.step
      });
    } else {
      this.$store.dispatch("SUBMIT_REQUEST_STEP_THREE", this.dataForm);
      this.$store.dispatch("SET_STATE_TO_FIVE");

      this.$emit("stepNext", {
        step: this.$store.state.solicitud.step
      });
    }
  }

  private forceUpper(value: any) {
    if (!value) {
      return "";
    }
    value = value.toString();
    return value.toUpperCase();
  }
}
